'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * model请求缓存部分处理
 * Created by spring on 2018/9/5.
 */

// 全局缓存对象
window.miHoYoEventModelMemoryCache = {};

var DEFAULT_NAME = 'defaultData';

var Store = exports.Store = function () {
  // 构造
  function Store() {
    var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_NAME;

    _classCallCheck(this, Store);

    if (!window.miHoYoEventModelMemoryCache[name]) {
      window.miHoYoEventModelMemoryCache[name] = {};
    }
    this.data = window.miHoYoEventModelMemoryCache[name];
  }

  _createClass(Store, [{
    key: 'get',
    value: function get(key) {
      return this.data[key];
    }
  }, {
    key: 'set',
    value: function set(key, data) {
      this.data[key] = data;
    }
  }]);

  return Store;
}();

var defaultStore = new Store();

exports.default = defaultStore;